module.exports = __webpack_public_path__ + "img/avatar-1.f29f6e97.svg";